<mat-tab-group dynamicHeight class="container">
  <mat-tab label="ยอดวันนี้">
    <div class="tab-content">
      <p>ยอดรวม: {{sellAmount | number:'1.2'}}</p>
      <div class="center-display">
        <table mat-table [dataSource]="sellToDay" class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let index = index"> {{index+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="product_id">
            <th mat-header-cell *matHeaderCellDef> รหัสสินค้า </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> ชื่อ </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="sum">
            <th mat-header-cell *matHeaderCellDef> จำนวน </th>
            <td mat-cell *matCellDef="let element"> {{element.sum}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="สินค้าขายดี">
    <div class="tab-content">
      <form [formGroup]="bestsellerForm" (submit)="bestseller()" class="fromFilter">
        <div>
          <label>วันเริ่ม</label>
          <input matInput formControlName="start" type="date">
          <label>วันสิ้นสุด</label>
          <input matInput formControlName="end" type="date">
        </div>
        <div>
          <button type="submit">ค้นหา</button>
        </div>
      </form>
      <div class="center-display">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let index = index"> {{index+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="product_id">
            <th mat-header-cell *matHeaderCellDef> รหัสสินค้า </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> ชื่อ </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="sum">
            <th mat-header-cell *matHeaderCellDef> จำนวน </th>
            <td mat-cell *matCellDef="let element"> {{element.sum}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="ยอดรายวัน">
    <div class="tab-content">
      <form [formGroup]="summaryByDayForm" (submit)="summaryByDay()" class="fromFilter">
        <div>
          <label>วันเริ่ม</label>
          <input matInput formControlName="start" type="date">
          <label>วันสิ้นสุด</label>
          <input matInput formControlName="end" type="date">
        </div>
        <div>
          <button type="submit">ค้นหา</button>
        </div>
      </form>
      <div class="center-display">
        <table mat-table [dataSource]="dataSourceDaily" class="mat-elevation-z8">
          <!-- Position Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> วันที่ </th>
            <td mat-cell *matCellDef="let element"> {{element.date | date:'dd/M/yyyy'}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="sum">
            <th mat-header-cell *matHeaderCellDef> ยอดขาย </th>
            <td mat-cell *matCellDef="let element"> {{element.sum | number:'1.2'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsDaily"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsDaily;"></tr>
        </table>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>